namespace TabAurous.Common {
    export interface SKUSplittingAttributeForm {
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        SuperTypeId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NewSKU: Serenity.IntegerEditor;
    }

    export class SKUSplittingAttributeForm extends Serenity.PrefixedContext {
        static formKey = 'Common.SKUSplittingAttribute';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUSplittingAttributeForm.init)  {
                SKUSplittingAttributeForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = CommonCategoryLookup;
                var w2 = CommonSubCategoryLookup;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(SKUSplittingAttributeForm, [
                    'ProductTypeId', w0,
                    'CategoryId', w1,
                    'SubCategoryId', w2,
                    'SuperTypeId', w0,
                    'BrandId', w0,
                    'CollectionId', w0,
                    'Pieces', w3,
                    'Weight', w4,
                    'NetWeight', w4,
                    'NewSKU', w3
                ]);
            }
        }
    }
}
